const ITEMS = [
  "ARQUITECTURA DE AUTOR",
  "28 DEPARTAMENTOS",
  "SAN CRISTÓBAL CENTRO",
  "ROOF GARDENS",
];

export default function Marquee() {
  const row = (
    <div className="flex items-center shrink-0">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display italic text-2xl sm:text-3xl px-8 text-[#f4f2ea]/70 whitespace-nowrap">{item}</span>
          <span className="text-[#bfa360] text-lg">✦</span>
        </span>
      ))}
    </div>
  );
  return (
    <div className="relative border-y border-white/5 bg-[#18231c] py-5 overflow-hidden" data-testid="marquee-section">
      <div className="marquee-track">
        {row}
        {row}
      </div>
    </div>
  );
}
